<template>

  <div class="vpay__step">

    <ion-icon
      name="ios-checkmark-circle-outline"
      class="vpay_success-icon animated heartBeat delay-1s"
    ></ion-icon>

    <h2 class="vpay__success-title">Thanks!</h2>

    <!--<p class="vpay__success-description">Your {{ $store.getters.frequency.type | formatFrequencyType('lowercase') }} payment of {{ $store.getters.amount | formatAmount }} has been successfully processed.</p>-->
    <p class="vpay__success-description">{{ transactionDescription }}</p>

    <div
      v-if="$store.getters.transactionResponse.transaction"
      class="vpay__input-container"
    >
      <el-button
        class="vpay__receipt-button"
        @click="onClickReceipt"
        round
      >Receipt #{{ $store.getters.transactionResponse.transaction.receipt_number }}</el-button>
    </div>

    <div class="vpay__input-container">
      <el-button
        class="vpay__next-button"
        @click="onClickBack"
        round
      >Make Another Payment</el-button>
    </div>

  </div>

</template>

<script>
export default {
  name: "PaymentFormStep4",

  computed: {
    transactionDescription() {
      const today = new Date();
      const startDate = new Date(this.$store.getters.frequency.startDate);
      const startDateFormatted = this.$options.filters.moment(
        startDate,
        "MMMM D, YYYY"
      );

      const type = this.$store.getters.frequency.type;
      const typeFormatted = this.$options.filters.formatFrequencyType(
        type,
        "lowercase"
      );

      const interval = this.$store.getters.frequency.interval;

      const amount =
        this.$store.getters.transactionResponse &&
        this.$store.getters.transactionResponse.transaction &&
        this.$store.getters.transactionResponse.transaction.amount
          ? this.$store.getters.transactionResponse.transaction.amount
          : this.$store.getters.finalAmount;
      const amountFormatted = this.$options.filters.formatAmount(amount);

      const description =
        this.$store.getters.transactionResponse &&
        this.$store.getters.transactionResponse.transaction &&
        this.$store.getters.transactionResponse.transaction.description
          ? this.$store.getters.transactionResponse.transaction.description
          : this.$store.getters.selectedCause.title;

      if (type === "recurring") {
        if (startDate > today) {
          return `Your ${interval} payment of ${amountFormatted} towards '${description}' is scheduled to start on ${startDateFormatted}.`;
        }
        return `Your first payment of ${amountFormatted} towards '${description}' was successful! This payment will recur ${interval} until cancelled.`;
      }

      return `Your payment of ${amountFormatted} towards '${description}' was successful!`;
    },
  },

  methods: {
    onClickBack() {
      this.$store.commit("resetPaymentForm");
    },

    onClickReceipt() {
      this.$store.commit(
        "receiptNumber",
        this.$store.getters.transactionResponse.transaction.receipt_number
      );
      this.$store.commit("displayComponentName", "TransactionReceipt");
    },
  },
};
</script>

<style>
</style>
